import React, { FC } from 'react';
import { TablesNames } from '../../store/tables/tables-context';
import { Table } from '../table/Table';
import { mockDetailData } from '../../store/tables/partners/partners-deals-details-data';
import { PageLink, PageTitle } from '../../layout/core';
import { useParams } from 'react-router-dom';
import { GoBackBtn } from '../header/GoBackBtn';

export const dealsDetailsBreadCrumbs: Array<PageLink> = [
	{
		title: 'MENU.DEALS',
		path: '/agencies/deals',
		isSeparator: false,
		isActive: false
	},
	{
		title: '',
		path: '',
		isSeparator: true,
		isActive: false
	}
];

export const AgenciesDealsDetailsPage: FC = () => {
	const { agencyId } = useParams();
	return (
		<>
			<PageTitle breadcrumbs={dealsDetailsBreadCrumbs}>{agencyId}</PageTitle>
			<div className="mb-5">
				<GoBackBtn path={'/agencies/deals'}/>
			</div>
			<Table
				name={TablesNames.partnersDealsDetailsTableData}
				data={mockDetailData}
				isLoading={false}
			/>
		</>
	);
};